import { createContext, useState, useEffect } from "react";
import axios from "../../utils/axios";

// Updated context with isAuthenticated property
export const UserContext = createContext({
  isAuthenticated: false,
  employee: {
      _id: "",
      firstName: "",
      lastName: "",
      role: "",
      jobs: [],
    },
});

export const UserProvider = ({ children }) => {
  const [auth, setAuth] = useState({
    isAuthenticated: false,
    employee: {
        _id: "",
        firstName: "",
        lastName: "",
        role: "",
        jobs: [],
      },
  });
  
  const [loading, setLoading] = useState(true);

  // Check session status on initial load
  useEffect(() => {
    const checkSession = async () => {
      try {
        const response = await axios.get("user/session", {
          withCredentials: true
        });
        
        if (response.data && !response.data.err) {
          setAuth({
            isAuthenticated: true,
            employee: {
              _id: response.data._id,
              firstName: response.data.firstName,
              lastName: response.data.lastName,
              role: response.data.role,
              jobs: [],
              }, 
          });
        }
      } catch (error) {
        console.log("Session check failed or user not logged in");
      } finally {
        setLoading(false);
      }
    };
    
    checkSession();
  }, []);

  return (
    <UserContext.Provider value={{ auth, setAuth, loading }}>
      {children}
    </UserContext.Provider>
  );
};
